import Surveys from "./Surveys.jsx"

export default Surveys;